<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div class = "mt-3 vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                disabled
                v-validate="'required|min:3'"
                data-vv-validate-on="blur"
                type="account"
                name="businessPackage"
                :label="$t('adminPackage.namePackage')"
                v-model="businessPackage.name"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("businessPackage")
              }}</span>
            </div>
          </div>
          <div class = "mt-3 vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                disabled
                v-validate="'required|numeric'"
                data-vv-validate-on="blur"
                type="account"
                name="totalKeyword"
                :label="$t('adminPackage.totalKeyword')"
                v-model="businessPackage.totalKeyword"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("totalKeyword")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                disabled
                v-validate="'required|numeric'"
                data-vv-validate-on="blur"
                type="account"
                name="totalData"
                :label="$t('adminPackage.totalData')"
                v-model="businessPackage.totalData"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("totalData")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                disabled
                v-validate="'required|numeric'"
                data-vv-validate-on="blur"
                type="account"
                name="totalSubAccount"
                :label="$t('adminPackage.totalSubAccount')"
                v-model="businessPackage.totalSubAccount"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("totalSubAccount")
              }}</span>
            </div>
          </div>
          <div class = "mt-3 vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                disabled
                v-validate="'numeric'"
                data-vv-validate-on="blur"
                type="account"
                name="totalDays"
                :label="$t('adminPackage.numberOfDays')"
                v-model="businessPackage.days"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("totalDays")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                disabled
                v-validate="'required|numeric'"
                data-vv-validate-on="blur"
                type="account"
                name="displayOrder"
                :label="$t('adminPackage.displayOrder')"
                v-model="businessPackage.displayOrder"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("displayOrder")
              }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                disabled
                v-validate="'numeric'"
                data-vv-validate-on="blur"
                type="account"
                name="price"
                :label="$t('adminPackage.price')"
                v-model="businessPackage.price"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("price")
              }}</span>
            </div>
          </div>
          <div class = "vx-row mt-3">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <label class="vs-input--label">{{$t('adminPackage.expiredDate')}}</label>
              <datepicker :format="'dd/MM/yyyy'" v-model="businessPackage.expiredDate"
                          data-vv-validate-on="input" name="expiredDate"></datepicker>
              <span class="text-danger text-sm">{{ errors.first('expiredDate') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{$t('adminPackage.approve')}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">{{ $t('accountUser.backUser') }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>

</template>
<script>

  import vSelect from 'vue-select'
  import Datepicker from '@/components/datepicker/Datepicker.vue';
  export default {
    data() {
      return {
        isUpdate: false,
        id: null,
        businessPackage: {},
      };
    },
    components: {
      vSelect,
      Datepicker
    },
    computed: {
      validateForm() {
        return !this.errors.any();
      },
    },
    created() {
      this.packageId = this.$route.query.id;
      if (this.packageId) {
        this.$vs.loading();
        this.$business.get('/user-package/admin-find-user-package-by-id/' + this.packageId).then((response) => {
          this.$vs.loading.close();
          if (!response.data.businessPackage) this.$router.go(-1)
          this.businessPackage = response.data.businessPackage;
          this.businessPackage.days = response.data.days;
          this.businessPackage.price = response.data.price;
          let times = 86400 * 1000 * (!isNaN(this.businessPackage.days) ? this.businessPackage.days : 30);
          this.businessPackage.expiredDate = new Date(new Date().getTime() + times)
          this.isUpdate = true;
        }).catch((err) => {
          this.$vs.loading.close();
          this.$router.go(-1)
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
    },
    methods: {
      async saveChanges(evt) {
        evt.preventDefault();
        if (!this.validateForm) return;

        const result = await this.$validator.validateAll();
        if (!result) return;
        this.businessPackage.status = 1;
        this.$vs.loading();
      this.$business.post(`/user-package/process/${this.packageId}`, this.businessPackage).then(() => {
          this.$vs.loading.close();
          this.$router.push('/admin/package/manage');
        }).catch((err) => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
    }
  };
</script>
